import { useCallback, useEffect, useRef, useState } from 'react';
import type { IVideoStreamItem } from '../types';
import { resolveMediafilePreviewResource } from './resolveMediafilePreviewResource';
import type { MediafilePreviewResource } from './previewTypes';

export const useMediafilePreview = (items: readonly IVideoStreamItem[]) => {
  const [openResource, setOpenResource] = useState<MediafilePreviewResource>();
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const closePreview = useCallback(() => {
    setOpenResource(undefined);
    if (triggerRef.current?.isConnected) triggerRef.current.focus({ preventScroll: true });
    triggerRef.current = null;
  }, []);
  const currentItem = openResource && items.find((item) => item.id === openResource.id);
  const currentResource = currentItem && resolveMediafilePreviewResource(currentItem);
  const isCurrent =
    !!openResource && currentResource?.uri === openResource.uri && currentResource.kind === openResource.kind;
  useEffect(() => {
    if (openResource && !isCurrent) closePreview();
  }, [openResource, isCurrent, closePreview]);
  const requestPreview = (id: string, trigger: HTMLButtonElement) => {
    const item = items.find((candidate) => candidate.id === id);
    const resource = item && resolveMediafilePreviewResource(item);
    if (resource) {
      triggerRef.current = trigger;
      setOpenResource(resource);
    }
  };
  return { previewResource: isCurrent ? openResource : undefined, requestPreview, closePreview };
};
